import { useSyncExternalStore } from 'react'
import { orderStore, type TrackedIntent } from './orders'

/**
 * Every tracked order, newest first — ROADMAP 4.13.
 *
 * Subscribes to the whole list rather than a slice: the Orders panel shows
 * all of it, and there are at most a few hundred. The per-slot subscription
 * the chain uses exists because 460 cells tick at 15 Hz; this does not.
 */
export function useOrders(): TrackedIntent[] {
  return useSyncExternalStore(orderStore.subscribe, orderStore.getSnapshot, orderStore.getSnapshot)
}
